import { SatelliteSensorType, zIndex } from "@nova/constants"
import { useSatelliteProvenanceData } from "plugins/Satellite/provenance/useSatelliteProvenanceData"
import type { SatelliteSceneManifestEntry } from "plugins/Satellite/provenance/useSatelliteProvenanceData"

type CursorPosition = { x: number; y: number }

export const SatelliteProvenanceTooltip = ({
    flightId,
    sensorType,
    scene,
    cursor,
}: {
    flightId: string
    sensorType: SatelliteSensorType | undefined
    scene: SatelliteSceneManifestEntry | undefined
    cursor: CursorPosition | undefined
}) => {
    const { activeScenes } = useSatelliteProvenanceData(flightId)

    if (!scene || !cursor) return null

    const totalContributedPixels =
        activeScenes?.reduce((sum, s) => sum + (s.contributedPixels ?? 0), 0) ?? 0
    const percentOfArea =
        totalContributedPixels && scene.contributedPixels !== undefined
            ? (scene.contributedPixels / totalContributedPixels) * 100
            : undefined
    const dateLabel = new Date(scene.datetime).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
    })

    return (
        <div
            className="pointer-events-none fixed bg-black-800 border border-gray-700 rounded-xl shadow-card px-3 py-2 flex flex-col gap-0.5"
            style={{ left: cursor.x + 16, top: cursor.y + 16, zIndex: zIndex.PortalledTooltip }}
        >
            <small className="text-gray-0">Scene from {dateLabel}</small>
            {sensorType !== SatelliteSensorType.Radar && scene.cloudCoverage != null && (
                <small className="text-gray-100">
                    {Math.round(scene.cloudCoverage)}% cloud coverage
                </small>
            )}
            {percentOfArea !== undefined && (
                <small className="text-gray-100">
                    {Math.round(percentOfArea)}% of selected area
                </small>
            )}
        </div>
    )
}
